import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  // Set a string value in local storage
  setStringItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  // Get a string value from local storage
  getStringItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  // Set a boolean value in local storage
  setBooleanItem(key: string, value: boolean): void {
    this.setItem<boolean>(key, value);
  }

  // Get a boolean value from local storage
  getBooleanItem(key: string): boolean | null {
    return this.getItem<boolean>(key);
  }

  setObjectItem<T extends object>(key: string, value: T): void {
    this.setItem<T>(key, value);
  }

  // Get a boolean value from local storage
  getObjectItem<T extends object>(key: string): T | null {
    return this.getItem<T>(key);
  }

  // Set a value in local storage
  private setItem<T extends boolean | number| object>(key: string, value: T): void {
    this.setStringItem(key, JSON.stringify(value));
  }

  // Get a value from local storage
  private getItem<T extends boolean | number| object>(key: string): T | null {
    const item = this.getStringItem(key);
    if (item) {
      return JSON.parse(item);
    }
    return null;
  }

  // Remove a value from local storage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items from local storage
  clear(): void {
    localStorage.clear();
  }

}
